import { Routes } from '@angular/router';
import { GuestGuard } from '../shared/guards/guest.guard';

export const authRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./login-page/login-page.component').then((c) => c.LoginPageComponent),
    canActivate: [GuestGuard],
  },
  {
    path: 'password-recovery',
    loadComponent: () =>
      import('./recovery-password/recovery-password.component').then((c) => c.RecoveryPasswordComponent),
    canActivate: [GuestGuard],
  },
  {
    path: 'reset-link',
    loadComponent: () => import('./reset-link/reset-link.component').then((c) => c.ResetLinkComponent),
    canActivate: [GuestGuard],
  },
  {
    path: 'set-new-password',
    loadComponent: () => import('./set-new-password/set-new-password.component').then((c) => c.SetNewPasswordComponent),
    canActivate: [GuestGuard],
  },
  {
    path: 'successfully-reset',
    loadComponent: () =>
      import('./successfully-reset/successfully-reset.component').then((c) => c.SuccessfullyResetComponent),
    canActivate: [GuestGuard],
  },
];
